import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { DestroyRef, Directive, inject, input, OnInit, output, signal } from '@angular/core';

@Directive({
  selector: '[animatable-heirarchy]'
})
export class AnimatableHeirarchy implements OnInit {
  private readonly parent = inject(AnimatableGroupDirective, { skipSelf: true, optional: true });
  private readonly directive = inject(AnimatableDirective, { self: true });

  public readonly ignoreParent = input(false, { transform: coerceBooleanProperty });

  ngOnInit() {
    const parent = !this.ignoreParent() && this.parent;
    if (parent) {
      parent.registerAnimatable(this.directive);
    }
  }
}

@Directive({
  selector: '[animatable]',
  hostDirectives: [
    AnimatableHeirarchy
  ]
})
export class AnimatableDirective {
  private readonly dRef = inject(DestroyRef);

  public readonly animationStart = output();
  public readonly animationEnd = output();


  public readonly animating = (() => {
    const $ = signal(false);

    this.animationStart
      .subscribe(() => $.set(true));

    this.animationEnd
      .subscribe(() => $.set(false));

    return $.asReadonly();
  })();

  constructor() {
    this.dRef.onDestroy(() => {
      if (this.animating())
        this.animationEnd.emit();
    });
  }
}


@Directive({
  selector: '[animatable-group]',
  hostDirectives: [
    AnimatableDirective
  ]
})
export class AnimatableGroupDirective {
  public readonly state = inject(AnimatableDirective, { self: true });

  private readonly current = new Set<AnimatableDirective>();

  public registerAnimatable(directive: AnimatableDirective) {
    directive.animationStart.subscribe(() => {
      if (this.current.has(directive))
        return;

      this.current.add(directive);

      this.state.animationStart.emit();
    });

    directive.animationEnd.subscribe(() => {
      if (!this.current.has(directive))
        return;

      this.current.delete(directive);
      this.state.animationEnd.emit();
    });
  }

}

